<template>
  <div class="registrazione-inviata">
    <h3 style="text-align: justify">{{ labels.complimenti }}</h3>
    <br />
    <p style="text-align: justify">
      {{ labels.un_email_e_stata_inviata }}: {{ indirizzo_email }}
    </p>
    <p style="text-align: justify">{{ labels.all_interno_della_mail }}</p>
    <b-link v-on:click="VaiALogin">{{ labels.vai_a_login }}.</b-link>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "RegistrazioneInviata",
  components: {},
  data() {
    return {
      labels: {},
      labels_errori: {},
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  props: {
    codice: String,
    descrizione: String,
    indirizzo_email: String,
  },
  methods: {
    VaiALogin() {
      try {
        this.$router.push("/login");
      } catch (error) {
        this.registraErrore(error, "RegistrazioneInviata-VaiALogin");
      }
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);

      let me = this;

      let parametri = {
        codice: this.codice,
        descrizione: this.descrizione,
        indirizzo_email: this.indirizzo_email,
        lingua: this.$store.state.Lingua,
        url: this.$store.state.LocalURL + "home/completaregistrazione",
        indirizzo_email_facile_checkin: this.$store.state.EmailFacileCheckIn,
      };

      let parametri_json = JSON.stringify(parametri);

      let ServerURL = this.$store.state.ServerURL;

      axios({
        method: "post",
        url: ServerURL + "CheckIn/InviaEmailRegistrazionePartner",
        data: parametri_json,
      })
        .then(function (response) {
          if (response.data.errore == 0) {
            //console.log("OK")
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "RegistrazioneInviata-created"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          me.registraErrore(error, "RegistrazioneInviata-created");
        });
    } catch (error) {
      this.registraErrore(error, "RegistrazioneInviata-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      complimenti:
        "Complimenti! I dati della registrazione sono stati inviati con successo !",
      un_email_e_stata_inviata: "Un email è stata inviata all'indirizzo",
      all_interno_della_mail:
        "All'interno dell'email è presente un link per confermare la registrazione. Se tale email non dovessere arrivare entro un tempo ragionevole, si prega di controllare tra la posta indesiderata (spam).",
      vai_a_login: "Vai a login",
    };
    let labels_inglese = {
      complimenti:
        "Complimenti! I dati della registrazione sono stati inviati con successo !",
      un_email_e_stata_inviata: "Un email è stata inviata all'indirizzo",
      all_interno_della_mail:
        "All'interno dell'email è presente un link per confermare la registrazione. Se tale email non dovessere arrivare entro un tempo ragionevole, si prega di controllare tra la posta indesiderata (spam).",
      vai_a_login: "Vai a login",
    };
    let labels_tedesco = {
      complimenti:
        "Complimenti! I dati della registrazione sono stati inviati con successo !",
      un_email_e_stata_inviata: "Un email è stata inviata all'indirizzo",
      all_interno_della_mail:
        "All'interno dell'email è presente un link per confermare la registrazione. Se tale email non dovessere arrivare entro un tempo ragionevole, si prega di controllare tra la posta indesiderata (spam).",
      vai_a_login: "Vai a login",
    };
    let labels_francese = {
      complimenti:
        "Complimenti! I dati della registrazione sono stati inviati con successo !",
      un_email_e_stata_inviata: "Un email è stata inviata all'indirizzo",
      all_interno_della_mail:
        "All'interno dell'email è presente un link per confermare la registrazione. Se tale email non dovessere arrivare entro un tempo ragionevole, si prega di controllare tra la posta indesiderata (spam).",
      vai_a_login: "Vai a login",
    };

    let labels_errori_italiano = {
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "RegistrazioneInviata-fn_CambiaLingua");
  }
}
</script>

<style scoped></style>
